import React from "react";
import { Grid, Stack, Box } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import FormTextField from "../components/common/FormTextField";
import SubmitButton from "../components/buttons/SubmitButton";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import {
  createCustomer,
  updateCustomer,
} from "../redux/actions/customerActions";
import { cleanFormData } from "../helpers/formHelpers";

const customerSchema = Yup.object({
  businessName: Yup.string().required("Business name is required"),
  contactName: Yup.string().required("Contact person name is required"),
  contactNumber: Yup.string()
    .matches(
      /^(\+254|254|0)?[71]\d{8}$/,
      "Invalid phone format (e.g. 0712345678)",
    )
    .required("Contact number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
});

const CreateOrUpdateCustomerForm = ({
  customer = null,
  isEditing = false,
  loading = false,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    businessName: customer?.businessName || "",
    contactName: customer?.contactName || "",
    contactNumber: customer?.contactNumber || "",
    email: customer?.email || "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={customerSchema}
      onSubmit={(values) => {
        const cleanedValues = cleanFormData(values);
        if (isEditing) {
          dispatch(updateCustomer({ id: customer.id, values: cleanedValues }));
        } else {
          dispatch(createCustomer(cleanedValues));
        }
      }}
      enableReinitialize
    >
      {({ dirty, isValid }) => (
        <Form>
          <Stack spacing={3}>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormTextField name="businessName" label="Business Name" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormTextField name="contactName" label="Contact Person" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormTextField
                    name="contactNumber"
                    label="Contact Number"
                    placeholder="07XXXXXXXX"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormTextField
                    name="email"
                    label="Email Address"
                    type="email"
                  />
                </Grid>
              </Grid>
            </Box>

            <SubmitButton
              title={isEditing ? "Update Customer" : "Register Customer"}
              loading={loading}
              disabled={!dirty || !isValid || loading}
              startIcon={
                isEditing ? <SaveOutlinedIcon /> : <AddCircleOutlineIcon />
              }
              sx={{ mt: 1 }}
            />
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default CreateOrUpdateCustomerForm;
